<template>
  <div ref="spinner" style="height: 100px" class="spinner" />
</template>

<script>
const animationData = require("@/assets/lottie/spinner.json");

export default {
  name: "FunctionizeLoader",
  components: {},
  data: () => ({
    animationData,
    interval: undefined,
  }),
  mounted() {
    this.interval = setInterval(() => {
      if (window?.lottie) {
        clearInterval(this.interval);
        this.interval = undefined;
        const params = {
          container: this.$refs.spinner,
          renderer: "svg",
          loop: true,
          autoplay: true,
          animationData: this.animationData,
        };
        window.lottie.loadAnimation(params);
      }
    }, 100);
  },
};
</script>

<style scoped></style>
